import { FC, Fragment, useState } from "react";
import { Moon, Sun, Monitor } from "lucide-react";
import { useTheme } from ".";
import { HEADER_BUTTON_STYLES, LARGE_ICON_SIZE_STYLES } from "../styles";
import { Button } from "./molecules/Button";

const variants = ["light", "dark", "system"];

const getIcon = (variant: string) => {
  if (variant === "light") return <Sun />;
  if (variant === "dark") return <Moon />;
  if (variant === "system") return <Monitor />;
};

export const ThemeSwitcher: FC<React.PropsWithChildren> = () => {
  const [active, setActive] = useState(false);
  const { theme, switchTheme } = useTheme();

  return (
    <div className="relative top-[-1.8px] z-10 flex h-10 w-10 md:top-[1.8px] md:h-9 md:w-9">
      <div
        className={`absolute right-0 flex rounded-full dark:bg-stone-800 md:bg-stone-100 ${
          active ? "top-[-4px] translate-x-1 transform p-1" : ""
        }`}
      >
        {active && (
          <div className="absolute inset-0 rounded-full bg-stone-800 dark:bg-stone-800 md:bg-stone-100" />
        )}
        {variants.map((variant) => {
          const selected = theme === variant;
          return (
            <Fragment key={variant}>
              {(selected || active) && (
                <Button
                  title="variant"
                  tooltip={variant}
                  key={variant}
                  onClick={() => {
                    if (!active) {
                      return setActive(true);
                    }
                    setActive(false);
                    return switchTheme(variant);
                  }}
                  buttonType="iconOnly"
                  className={`${HEADER_BUTTON_STYLES} z-1 relative shrink-0 md:bg-stone-100 dark:bg-stone-800 md:p-1 dark:hover:bg-stone-700 dark:hover:text-stone-100 md:hover:bg-stone-200 md:hover:text-stone-700`}
                >
                  {!active && selected && (
                    <span className="absolute inset-0 block h-full w-full rounded-full" />
                  )}
                  <span
                    className={`z-20 flex justify-center ${LARGE_ICON_SIZE_STYLES}`}
                  >
                    {getIcon(variant)}
                  </span>
                </Button>
              )}
            </Fragment>
          );
        })}
      </div>
    </div>
  );
};
